var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-poster"},[(_vm.img)?_c('img',{attrs:{"src":_vm.img,"alt":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }